import { injectable } from 'inversify';
import { action } from 'mobx';
import { MipHub, MipService } from './Mip.service';
import { operationModeTimeInSec } from './MipEnvValue';
import { config } from '@/config/app.config';

@injectable()
export class IFrameController {
  private _mipService: MipService | undefined;

  @action
  public initMipIntegration(sid: string): void {
    const iFrame = document.getElementById('mipFrame') as HTMLIFrameElement;
    if (iFrame.contentDocument?.body) {
      iFrame.contentDocument.body.textContent = 'MIP frame';
    }

    const script = iFrame.contentDocument?.createElement('script') as HTMLScriptElement;
    script.src = config.mip.mipClientURL;

    iFrame.contentDocument?.body.appendChild(script);

    script.addEventListener('load', (): void => {
      if (iFrame.contentWindow) {
        const mipHubClientWindow = iFrame.contentWindow as unknown as  {miphubclient: {default: MipHub}};
        const mipHub = mipHubClientWindow.miphubclient.default;
        this._mipService = new MipService(mipHub, config.mip.logoutURL, sid, operationModeTimeInSec);
        this._mipService.init();
      }
    });
  }

  public get mipService(): MipService {
    if (!this._mipService) {
      throw new Error('mip service should be defined');
    }
    return this._mipService;
  }
}
